module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "ContentsPage"
  }, [_c('h1', {
    attrs: {
      "id": "heading_id_2"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/Text/Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "Space"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "#/Text/Introduction"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('div', {
    staticClass: "Space"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "#/Text/Introduction#BibleOneBook"
    }
  }, [_vm._v("The Bible is one book")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/Text/Introduction#KingdomGod"
    }
  }, [_vm._v("The kingdom of God")])])]), _vm._v(" "), _c('ol', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ChapterTitle"
  }, [_vm._v("The pattern of the kingdom")])])]), _vm._v(" "), _c('p', [_vm._v("Bible study: Genesis 1:1 – 2:25")])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ChapterTitle"
  }, [_vm._v("The perished kingdom")])])]), _vm._v(" "), _c('p', [_vm._v("Bible study: Genesis 3")])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ChapterTitle"
  }, [_vm._v("The promised kingdom")])])]), _vm._v(" "), _c('p', [_vm._v("Bible study: Genesis 17:1–8; Galatians 3:6–14")])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ChapterTitle"
  }, [_vm._v("The partial kingdom")])])]), _vm._v(" "), _c('p', [_vm._v("God’s people: Genesis 12 – Exodus 18")]), _vm._v(" "), _c('p', [_vm._v("God’s rule and blessing")]), _vm._v(" "), _c('p', [_vm._v("Bible study: Exodus 19:1–13; 20:1–17")]), _vm._v(" "), _c('p', [_vm._v("God’s place")]), _vm._v(" "), _c('p', [_vm._v("God’s king")]), _vm._v(" "), _c('p', [_vm._v("Bible study: 2 Samuel 7:1–17")])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ChapterTitle"
  }, [_vm._v("The prophesied kingdom")])])]), _vm._v(" "), _c('p', [_vm._v("Bible study: Hosea 1 – 3")])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ChapterTitle"
  }, [_vm._v("The present kingdom")])])]), _vm._v(" "), _c('p', [_vm._v("Bible study: Luke 1:39–80; 2:25–32")])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ChapterTitle"
  }, [_vm._v("The proclaimed kingdom")])])]), _vm._v(" "), _c('p', [_vm._v("Bible study: 2 Corinthians 4")])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ChapterTitle"
  }, [_vm._v("The perfected kingdom")])])]), _vm._v(" "), _c('p', [_vm._v("Bible study: Revelation 21:1–8; 21:22 – 22:5")])])]), _vm._v(" "), _c('div', {
    staticClass: "Space"
  }, [_c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('div', {
    staticClass: "Space"
  }, [_c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', [_vm._v("If you would like to run a course based on this material, downloadable resources are available from "), _c('a', {
    attrs: {
      "href": "https://ivpbooks.com/commentaries-and-group-resources",
      "target": "_blank"
    }
  }, [_vm._v("ivpbooks.com/commentaries-and-group-resources")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa8cef8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Contents.vue
// module id = 69
// module chunks = 0